module.exports = __webpack_public_path__ + "assets/img/study_3.4e5523c5.png";